import { LeaveSwitchProps } from "../../types";

const LeaveToggleSwitch = ({ isFullDay, handleToggle }: LeaveSwitchProps) => {
  return (
    <label className="leave-toggle-switch d-block">
      <input
        type="checkbox"
        className="leave-toggle-switch-input"
        checked={isFullDay === "Full Day" ? false : true}
        onChange={handleToggle}
      />

      {/* <span className={`span-${isFullDay ? "custom" : "fullday"}`}> */}
      {/* {isFullDay ? "Full Day" : "Custom"} */}
      {/* </span> */}

      <span className="leave-toggle-switch-slider">{isFullDay}</span>
    </label>
  );
};

export default LeaveToggleSwitch;
